import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseURL } from "services/api";

import { SignUpRequest, SignUpResponse } from "./types";

const baseQuery = fetchBaseQuery({
  baseUrl: `${baseURL}/auth`,
  prepareHeaders: (headers) => {
    headers.set("Accept", "application/json");
    headers.set("Content-Type", "application/json");
    return headers;
  },
});

export const authApi = createApi({
  reducerPath: "authService",
  baseQuery,
  endpoints: (builder) => ({
    signUp: builder.mutation<SignUpResponse, SignUpRequest>({
      query: (signUpRequest: SignUpRequest) => ({
        url: "/",
        method: "POST",
        body: signUpRequest,
      }),
    }),
  }),
});

export const { useSignUpMutation } = authApi;
